export default {
	Delete: 'Delete',
	Add: 'Add',
	DownloadCsv: 'Download as CSV',
};
